import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import isExternal from "utils/isExternalLink";
import styles from "./LinkButton.module.scss";

interface Props {
    href: string;
    children: React.ReactElement | string;
    className?: string;
}

export const ExternalLink = ({ href, className, children }: Props) => {
    return (
        <a
            className={classNames(styles["link-button"], className)}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
};

const LinkButton = ({ href, children, className }: Props) => {
    if (isExternal(href)) {
        return (
            <ExternalLink href={href} className={className}>
                {children}
            </ExternalLink>
        );
    }

    const handleScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        //Remove everything before the hash
        const targetId = e.currentTarget.href.replace(/.*\#/, "");
        const elem = document.getElementById(targetId);
        elem?.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <Link
            className={classNames(styles["link-button"], className)}
            to={href}
            onClick={handleScroll}
        >
            {children}
        </Link>
    );
};

export default LinkButton;
